import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { MatSpinner, MatButton } from '@angular/material';
import { ModificationAlertService } from './modification-alert.service';
import { ModificationAlertComponent } from './modification-alert.component';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[modificationAlert]'
})
export class ModificationAlertDirective implements OnInit {

  @Input('modificationAlert') showAlert: any;
  originalInnerText: string;
  spinner;

  constructor(
    private modificationAlertService: ModificationAlertService,
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {  }

  ngOnInit() {
    // Record the button's original text
    // this.originalInnerText = this.el.nativeElement.innerText;

    // Set the button to maintain the same dimensions, even once we put the spinner inside.
    this.el.nativeElement.style.display = 'flex';
    this.el.nativeElement.style.alignItems = 'center';
    this.el.nativeElement.style.justifyContent = 'center';

    // Create the spinner
    const factory = this.componentFactoryResolver.resolveComponentFactory(ModificationAlertComponent);
    const componentRef = this.viewContainerRef.createComponent(factory);

    this.spinner = componentRef.location;
    // console.log(this.showAlert);

    // Configure the spinner
    // this.spinner.strokeWidth = 3;
    // this.spinner.diameter = 18;



    // Hide the spinner
    if (!this.showAlert) {
      this.renderer.setStyle(this.spinner.nativeElement, 'display', 'none');
    }
    // this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'none');
    // this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'margin-left', '10px');

    this.onChanges();
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
  //   // Add '${implements OnChanges}' to the class.
  //   console.log(changes);
  // }

  // ngAfterContentChecked(): void {
  //   //Called after every check of the component's or directive's content.
  //   //Add 'implements AfterContentChecked' to the class.
  //   // console.log(this.f.dominio.hasError('either'));
  //   console.log(this.teste);
  // }

  onChanges() {
    this.modificationAlertService.getStatusAlert()
      .subscribe(arg => {
        if (arg) {
          // console.log(arg);
          this.renderer.appendChild(this.el.nativeElement, this.spinner.nativeElement);
          this.renderer.setStyle(this.spinner.nativeElement, 'display', 'inline-block');
        } else {
          this.el.nativeElement.style.display = 'none';
          this.renderer.setStyle(this.spinner.nativeElement, 'display', 'none');
          this.renderer.removeChild(this.el.nativeElement.firstChild, this.spinner.nativeElement);
        }
      });
  }
}
